import React, { useState, useEffect } from 'react';
import { withRouter, Link } from "react-router-dom";
import { withLocalize } from 'react-localize-redux';
import { useDispatch } from 'react-redux';
import { getFeedbackListAction,famousProviderList, getImageDataListAction, providerList,specializationList } from '../../Actions/User.action';
import { Dialog } from "@blueprintjs/core";
import MetaTags from 'react-meta-tags';
import LoginPageComponent from './Login/LoginPage.js';
import SignUp from '../SignUp/SignUp';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Marquee from 'react-marquee-master';
import Axios from 'axios';

const testimonialState = {
  responsive: {
    0: {
      items: 1,
    },
    769: {
      items: 2,
    },
  },
}

const HomePage = ({ history }) => {
  const dispatch = useDispatch();
  const [isSignupForm, setIsSignupForm] = useState(false);
  const [feedbackList, setFeedbackList] = useState({});
  const [itemData, setItemData] = useState([]);
  const [imageData, setImageData] = useState([]);
  const [doctorData, setDoctorData] = useState([]);

  const getFeedbackListFunction = async () => {
    let feedbackData = await getFeedbackListAction();
    setFeedbackList(feedbackData);
  }

  // const [providerList, setProviderList] = useState({});

  // const providerListAction = async () => {
  //   let providerData = await providerList();
  //   console.log("providerData",providerData)
  //   setProviderList(providerData);
  // }

  const [famousPriderList, setFamousPriderList] = useState({});


  const getFamouseProviderListFunction = async () => {
    let famousProviderData = await famousProviderList();
    console.log("gggggggggg",famousProviderData)
    setFamousPriderList(famousProviderData);
  }



  useEffect(() => {
    getFeedbackListFunction();
    // providerListAction();
    getFamouseProviderListFunction();
    itemDatafun();
  }, []);

  useEffect(() => {
    itemDatafun();
  }, [feedbackList]);

  useEffect(() => {
    itemDatafunn();
  }, [famousPriderList]);


  const getImageDataListFunction = async () =>{
    let imgData = await providerList({})
    setImageData(imgData.data)  
  }

  const getSpecializationListFunction = async () =>{
    let imgData = await specializationList({})
    setDoctorData(imgData.data)  
  }


  useEffect(() =>{
    getImageDataListFunction();
    getSpecializationListFunction();
  }, [])


  const [doctor, register] = useState("Register as a recover client");
  const [specialist, specialtype] = useState("Find a Specilist"); 

  const handleChange = (event) => {
    register(event.target.value);
    specialtype(event.target.value);
  }
  const itemDatafun = () => {
    console.log(feedbackList)
    let data = feedbackList?.data?.map((item, index) => {
      return (
        <div className="item" key={index}>
          <div className="single-testimonial-box style2">
            <div className="inner-box">
              <div className="image-holder">
                <img
                  src={`${process.env.REACT_APP_STATIC_S3_URL + item.feedbackDoc}`}
                  alt="example"
                  onError={(e) => {
                    e.target.src = "/static/img/icon-profiles.png"
                    e.target.style = ''
                  }}
                />
              </div>
              <div className="title-holder">
                <h4>{item.name ? item.name : '-'}</h4>
                <p className="ption">{item.title ? item.title : '-'}</p>
                <p className="ption">{item.subject ? item.subject : '-'}</p>
              </div>
            </div>
            <div className="text-holder">
              <div className="icon-holder">
                <span className="icon-interface-1">
                  <i className="fas fa-quote-left"></i></span>
              </div>
              <div className="text">
                <p>
                  {item.description && item.description.length > 160 &&
                    <span>
                      {item.description.substr(0, 160).replace(/<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g, ' ') + "... "}
                      <Link to={{ pathname: "feedback-detail", state: { id: item } }} className="js-scroll-trigger">Read More</Link>
                    </span>
                  }
                  {item.description && item.description.length <= 160 ?
                    item.description.replace(/<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g, ' ') : ''
                  }
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    });
    setItemData(data)

  }
  const itemDatafunn = () => {
    console.log(famousPriderList)
    let data = famousPriderList?.data?.map((item, index) => {
      return (
        <div className="item" key={index}>
          <div className="single-testimonial-box style2">
            <div className="inner-box">
              <div className="image-holder">
                <img
                  src={`${process.env.REACT_APP_STATIC_S3_URL + item.providerImage}`}
                  alt="example"
                  onError={(e) => {
                    e.target.src = "/static/img/icon-profiles.png"
                    e.target.style = ''
                  }}
                />
              </div>
              <div className="title-holder">
                <h4>{item.firstName ? item.firstName : '-'}</h4>
                <p className="ption">{item.fullName ? item.fullName : '-'}</p>
                <p className="ption">{item.contact ? item.contact : '-'}</p>
              </div>
            </div>
            <div className="text-holder">
              <div className="icon-holder">
                <span className="icon-interface-1">
                  <i className="fas fa-quote-left"></i></span>
              </div>
              <div className="text">
                <p>
                  {item.description && item.description.length > 160 &&
                    <span>
                      {item.description.substr(0, 160).replace(/<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g, ' ') + "... "}
                      <Link to={{ pathname: "feedback-detail", state: { id: item } }} className="js-scroll-trigger">Read More</Link>
                    </span>
                  }
                  {item.description && item.description.length <= 160 ?
                    item.description.replace(/<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g, ' ') : ''
                  }
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    });
    setItemData(data)

  }

  return (
    <div className="slide-er">
      <MetaTags>
        <title>Recover - Physical Therapy Treatment California</title>
        <meta name="description" content="Get physical therapy treatment in California with Recover without missing appointments due to scheduling issues. And provider can bridge gaps in their schedule!" />
        <meta name="keywords" content="telehealth, providers near me , Find A Provider, Online Therapy San Diego, Find the Right Provider, Teletherapy , Best Provider/Counselors Near Me in San Diego, Virtual Therapy, Clinical Psychologist, Find best Psychologist near me, Best Psychologists in San Diego, best physical therapy near me, physical therapy in californai, providers near me, best psychologist near san diego, psychology today find a provider , recover healthcare san diego, top psychologist near me, psychotherapy san diego, physical therapy specialist san diego, online physical therapy programs near san diego, physical therapy california, virtual physical therapy near san diego, advanced physical therapy, virtual provider in california, recover healthcare california, recovery health services san diego, physical therapy in california, find a provider in san diego, top rated physical therapy near san diego, physical therapy facilities near me, physical therapy around me, provider therapy near me, physical provider california, physical therapy san diego, physical therapy los angeles, telehealth solutions, select physical therapy los angeles, best recovery healthcare in san diego, telehealth solutions in san diego, good psychologist near me, clinical psychologist california, provider santa maria, digital telehealth solutions, physical therapy livermore ca, find a provider in california, how to find the right provider for me, san diego psychotherapy and wellness center, independent provider california, recover healthcare, recovery health services, best recovery healthcare, online provider san diego, physical therapy Clinic near me, Telehealth physical therapy California, Virtual physical therapy California, Face time physical therapy California, physical therapy treatment San Diego, Provider San Diego, Telehealth physical therapy San Diego, Virtual physical therapy San Diego, Face time physical therapy San Diego, Independent Provider San Diego, Clinic Provider San Diego, provider Services San Diego" />
      </MetaTags>

      <section className="masthead" id="home">
        <div className="container">
          <div className="main-row-banner">
            <div className="row ">
              <div className="col-lg-6 text-center d-table">
                <div className="vertical-middle d-table-cell">
                <h1 className="mx-auto my-0 mb-5  ">
                  Regain Optimal Health with Reliable <b>Telehealth Services</b>
                </h1> 
                {/* <h2 className="text-white-80 mx-auto mt-2 mb-5">
              Recover is a health care platform focused on connecting patients with world-class physical providers. Recover ensures patients no longer have to miss an opportunity of physical therapy treatment due to conflicts in their schedule. The platform also ensures physical therapists’ fewer gaps in their schedule, therefor reducing loss of revenue.
              </h2> */}
                {(!localStorage.getItem("RecoverWebStatus")) &&
                  <Link to='#' className="btn btn-primary regis" onClick={e => setIsSignupForm(true)}>Learn More</Link>
                }
              </div>
              </div>
              <div className="col-lg-6 mx-auto">

                {/* <marquee direction="up" >
                  <div className='row'>
                    <div className='col-sm-6 md-w-50'>
                      <div className='img-box'>
                        <img src="/static/img/doc-1.png" alt="about" />
                        <h5 className='text-center text-white'>Life Coaching</h5>  
                      </div>                     
                    </div>
                    <div className='col-sm-6 md-w-50'>
                      <div className='img-box'>
                        <img src="/static/img/doc-2.png" alt="about" />
                        <h5 className='text-center text-white'>Registered Dietitian</h5>  
                      </div>                     
                    </div>
                    <div className='col-sm-6 md-w-50'>
                      <div className='img-box'>
                        <img src="/static/img/doc-3.png" alt="about" />
                        <h5 className='text-center text-white'>Child Psychologist</h5>  
                      </div>                     
                    </div>
                    <div className='col-sm-6 md-w-50'>
                      <div className='img-box'>
                        <img src="/static/img/doc-4.png" alt="about" />
                        <h5 className='text-center text-white'>Occupational Therapy </h5>  
                      </div>                     
                    </div>
                  </div>
                   
                  <div className='row'>
                    <div className='col-sm-6 md-w-50'>
                      <div className='img-box'>
                        <img src="/static/img/doc-1.png" alt="about" />
                        <h5 className='text-center text-white'>Life Coaching</h5>  
                      </div>                     
                    </div>
                    <div className='col-sm-6 md-w-50'>
                      <div className='img-box'>
                        <img src="/static/img/doc-2.png" alt="about" />
                        <h5 className='text-center text-white'>Registered Dietitian</h5>  
                      </div>                     
                    </div>
                    <div className='col-sm-6 md-w-50'>
                      <div className='img-box'>
                        <img src="/static/img/doc-3.png" alt="about" />
                        <h5 className='text-center text-white'>Child Psychologist</h5>  
                      </div>                     
                    </div>
                    <div className='col-sm-6 md-w-50'>
                      <div className='img-box'>
                        <img src="/static/img/doc-4.png" alt="about" />
                        <h5 className='text-center text-white'>Occupational Therapy </h5>  
                      </div>                     
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-sm-6 md-w-50'>
                      <div className='img-box'>
                        <img src="/static/img/doc-1.png" alt="about" />
                        <h5 className='text-center text-white'>Life Coaching</h5>  
                      </div>                     
                    </div>
                    <div className='col-sm-6 md-w-50'>
                      <div className='img-box'>
                        <img src="/static/img/doc-2.png" alt="about" />
                        <h5 className='text-center text-white'>Registered Dietitian</h5>  
                      </div>                     
                    </div>
                    <div className='col-sm-6 md-w-50'>
                      <div className='img-box'>
                        <img src="/static/img/doc-3.png" alt="about" />
                        <h5 className='text-center text-white'>Child Psychologist</h5>  
                      </div>                     
                    </div>
                    <div className='col-sm-6 md-w-50'>
                      <div className='img-box'>
                        <img src="/static/img/doc-4.png" alt="about" />
                        <h5 className='text-center text-white'>Occupational Therapy </h5>  
                      </div>                     
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-sm-6 md-w-50'>
                      <div className='img-box'>
                        <img src="/static/img/doc-1.png" alt="about" />
                        <h5 className='text-center text-white'>Life Coaching</h5>  
                      </div>                     
                    </div>
                    <div className='col-sm-6 md-w-50'>
                      <div className='img-box'>
                        <img src="/static/img/doc-2.png" alt="about" />
                        <h5 className='text-center text-white'>Registered Dietitian</h5>  
                      </div>                     
                    </div>
                    <div className='col-sm-6 md-w-50'>
                      <div className='img-box'>
                        <img src="/static/img/doc-3.png" alt="about" />
                        <h5 className='text-center text-white'>Child Psychologist</h5>  
                      </div>                     
                    </div>
                    <div className='col-sm-6 md-w-50'>
                      <div className='img-box'>
                        <img src="/static/img/doc-4.png" alt="about" />
                        <h5 className='text-center text-white'>Occupational Therapy </h5>  
                      </div>                     
                    </div>
                  </div>
                </marquee> */}
               <marquee direction="up"  >
                  <div className='row'>
                    {
                      imageData.map((image) => {
                        return <div className='col-sm-6 md-w-50'
                          key={image.id}>
                          <div className="img-box">
                            <img src= {`${process.env.REACT_APP_STATIC_S3_URL + image.profileImg}`} />
                            {/* <h5 className='text-center text-white'>{image.fullName}</h5> */}
                              <div className='text-center text-white'>
                              {
          image.specialization?.map(function(ttttt, index) {
            return <span key={`demo_snap_${index}`}>{ (index ? ', ' : '') + ttttt.specializationName }</span>;
          })
        }
                                </div>
                          </div>
                        </div>
                      })
                    }
                  </div>
                </marquee>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-lg-3 p-1 text-center"><div className='home-banner-form d-flex justify-content-center'><i className="fa fa-search" aria-hidden="true"></i><h5 className='pl-3'> I would like to</h5></div></div>
              <div className="col-lg-6   p-1 text-center">
                <div className='home-banner-form'>
                  <form>
                    <select value={doctor}  onClick={e => setIsSignupForm(true)} >
                      <option value="1" >Register as a Recover Client, Independent Provider And Clinic With Recover</option>
                      {/* {(!localStorage.getItem("RecoverWebStatus")) &&
                  <Link to='#' className="btn btn-primary regis" onClick={e => setIsSignupForm(true)}> More</Link>
                } */}
                      {/* <option value="3">Become a Recover Independent Provider</option>
                      <option value="2">Register Clinic With Recover</option> */}
                    </select>
                  </form>
                </div>

              </div>
              {/* <div className="col-lg-3 p-1 text-center">
                <div className='home-banner-form'>
                  <form>
                    <select value={specialist} >
                      <option value="2" >Find a Clinic</option>
                      <option value="1">Child Psychologist</option>                     
                      <option value="3">Life Coaching </option>
                    </select>
                  </form>
                </div>
              </div> */}
               <div className="col-lg-3 p-1 text-center">
                <div className='home-banner-form'>
                  <form>
                  <Link className='Blacc' to="/FindSpecialist"><h5  className='Blacc'>Find A Specialist </h5></Link>
                    {/* <select value={specialist} >
                      <option value="2" >Find a Speciality</option>
                      {doctorData.map((item, index) => {
							return <option key={item._id} value={item._id}>
							  {item.name}
							</option>
						  })}
                       
                    </select> */}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section text-center" id="about">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 text-left d-table">
              <div className='vertical-middle d-table-cell'>
                <div className="section_title">
                  <h3>Welcome To Recover: Schedule Your <b>Telehealth Appointments</b> Today</h3>
                  <div className="decor2"></div>
                </div>
                <p className='pb-4'>
                Welcome to Recover.healthcare, your premier telehealth platform, designed to offer seamless and immediate access to Telehealth and Telemedicine Services in California, anytime and anywhere you require. In addition to serving clients, Recover empowers healthcare providers to efficiently manage cancellations within their practice and expand their patient base. Our mission is to unite individuals with top-tier healthcare providers, ensuring a pathway to renewed health and wellness.
                </p>

                <Link className="btn btn-primary js-scroll-trigger" to="/about-us">About Us</Link>
              </div>
            </div>
            <div className="col-lg-6 mx-auto">
              {(!localStorage.getItem("RecoverWebStatus")) ?
                (<LoginPageComponent history={history} />) :
                (<img src="/static/img/about.jpg" alt="about" />)
              }
            </div>
          </div>
        </div>
      </section>

      <section className="how-section bg-light" id="how">
        <div className="container">
          <div className="row">
            <div className="col section_title text-center">
              <h3>How Our <b>Healthcare Technology Solutions</b> Work</h3>
              <div className="decor"></div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="hs text-center pb-5">
                <img src="/static/img/patient.svg" alt="" />
                <h5 >Clients</h5>
                <p className='ellipsis-p'>
                Recover simplifies the process of receiving virtual healthcare from the location of your choice. Our intuitive calendar tool lets you set your availability at your convenience, allowing us to match you with a specialist during your selected time slots for your <b>telehealth doctor appointments</b>. You can easily upload any relevant medical documents to enhance the provider's assessment and treatment. After each visit, you'll have seamless access to your treatment notes.
                </p>
              </div>
              <div className="hs text-center pt-5">
                <img src="/static/img/Patient_PT.svg" alt="" />
                <h5>Independent Providers</h5>
                <p className='ellipsis-p'>
                Recover is actively recruiting licensed and qualified specialists to deliver <b>healthcare recovery services</b> to clients through our telehealth platform. If you're an independent contractor with a valid California healthcare license or certification and liability insurance, Recover will compensate you per client visit. You can use our calendar interface to mark your availability, and we'll connect you with clients that match your schedule. With Recover, you can build your own practice.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="mHero text-center mt-5">
                <img src="/static/img/phone.png" className="w-100 img-fluid" alt="" />
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="hs text-center pb-5">
                <img src="/static/img/clinic.svg" alt="" />
                <h5>Clinics</h5>
                <p className='ellipsis-p'>
                Recover provides an efficient solution for clinics dealing with last-minute client cancellations. Clinics can mark available slots using our calendar interface, and we'll pair your providers with clients available during those times. Recover's mission is to minimize revenue loss due to last-minute cancellations for clinics.
                </p>
              </div>
              <div className="hs text-center pt-5">
                <img src="/static/img/clinic PT.svg" alt="" />
                <h5>Clinic Providers</h5>
                <p className='ellipsis-p'>
                Recover assists in filling your cancellations during work hours and offers the opportunity to treat clients through telehealth. Your clinic administrator will provide a unique 'clinic code' for accessing your Recover account. You or your administrator can mark your availability, and we'll pair you with clients available during those times. If your clinic approves independent client treatment outside regular hours or on weekends, you have the option to do so through Recover. Clinic-based providers independently need to provide a copy of their California license/certification, W9, and proof of liability insurance.

                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="btn_section text-center">
                <Link className="btn btn-primary js-scroll-trigger" to="/how-recover-works">View more</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="video-section bg-light pb-100 pt-5">
        <div className="container">
        <div className="row">
            <div className="col section_title text-center">
              <h3>Explore Our <b>Digital Health Solutions</b></h3>
              <div className="decor"></div>
            </div>
          </div>
        <div><iframe width="100%" height="500" src="https://www.youtube.com/embed/tNTiztFuT3o" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div> 
        <div className="row">
            <div className="col section_title text-center">
              <p className='mt-4'>Explore a world of health and wellness knowledge every Tuesday with our insightful video series. Our engaging healthcare topics cover everything from wellness tips to expert insights, ensuring you're well-equipped to make informed decisions about your health. Subscribe now to embark on a journey of learning and empowerment with Recover.healthcare.</p>
              <div className="decor"></div>
            </div>
          </div>
       </div>
      </section>

      {/* <section className="testimonial-area provider-section">
        <div className="container">
          <div className="row">
            <div className="col section_title text-center">
              <h3 className="text-capitalize mb-4">Famous Provider's Profile </h3>
              <div className="decor"></div>
            </div>
          </div>
          <div className="row">
            {famousPriderList && famousPriderList.data && famousPriderList.data.length > 0 && (
              <OwlCarousel className="owl-theme"
                loop={true} margin={10}
                dots={false} autoplay={true}
                autoplayTimeout={6000} items={famousPriderList.data.length === 1 ? 1 : 2} //nav={true}
                responsive={famousPriderList.data.length === 1 ? testimonialState.responsive[0] : testimonialState.responsive}>

                {famousPriderList.data.map((item, index) => {
                  return (
                    <div className="item" key={index}>
                      <div className="single-testimonial-box style2">
                        <div className="inner-box">
                          <div className="image-holder">
                            <img
                              src={`${process.env.REACT_APP_STATIC_S3_URL + item.providerImage}`}
                              alt="No Profile Pic"
                              onError={(e) => {
                                e.target.src = "/static/img/icon-profiles.png"
                                e.target.style = ''
                              }}
                            />
                          </div>
                          <div className="title-holder">
                            <h4>{item.firstName ? item.firstName : '-'}</h4>
                            <p className="ption">{item.fullName ? item.fullName : '-'}</p>
                            <p className="ption">{item.contact ? item.contact : '-'}</p>

                            <div className="text">
                              <p>
                                {item.description && item.description.length > 160 &&
                                  <span>
                                    {item.description.substr(0, 160).replace(/<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g, ' ') + "... "}
                                    <Link to={{ pathname: "feedback-detail", state: { id: item } }} className="js-scroll-trigger">Read More</Link>
                                  </span>
                                }
                                {item.description && item.description.length <= 160 ?
                                  item.description.replace(/<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g, ' ') : ''
                                }
                              </p>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  );
                })}
              </OwlCarousel>
            )}
          </div>
        </div>
      </section> */}
      <section className="testimonial-area img-bg">
        <div className="container">
          <div className="row">
            <div className="col section_title text-center">
              <h3 className='text-white mb-4'>CUSTOMER FEEDBACK</h3>
              <div className="decor"></div>
            </div>
          </div>
          <div className="row">
            {feedbackList && feedbackList.data && feedbackList.data.length > 0 && (
              <OwlCarousel className="owl-theme"
                loop={true} margin={10}
                dots={false} autoplay={true}
                autoplayTimeout={6000} items={feedbackList.data.length === 1 ? 1 : 2} //nav={true}
                responsive={feedbackList.data.length === 1 ? testimonialState.responsive[0] : testimonialState.responsive}>

                {feedbackList.data.map((item, index) => {
                  return (
                    <div className="item" key={index}>
                      <div className="single-testimonial-box style2">
                        <div className="inner-box">
                          <div className="image-holder">
                            <img
                              src={`${process.env.REACT_APP_STATIC_S3_URL + item.feedbackDoc}`}
                              alt="example"
                              onError={(e) => {
                                e.target.src = "/static/img/icon-profiles.png"
                                e.target.style = ''
                              }}
                            />
                          </div>
                          <div className="title-holder">
                            <h4>{item.name ? item.name : '-'}</h4>
                            <p className="ption">{item.title ? item.title : '-'}</p>
                            <p className="ption">{item.subject ? item.subject : '-'}</p>
                          </div>
                        </div>
                        <div className="text-holder">

                          <div className="text">
                            <p>
                              {item.description && item.description.length > 160 &&
                                <span>
                                  {item.description.substr(0, 160).replace(/<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g, ' ') + "... "}
                                  <Link to={{ pathname: "feedback-detail", state: { id: item } }} className="js-scroll-trigger">Read More</Link>
                                </span>
                              }
                              {item.description && item.description.length <= 160 ?
                                item.description.replace(/<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g, ' ') : ''
                              }
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </OwlCarousel>
            )}
          </div>
        </div>
      </section>

      <Dialog
        className="form_designpage" onClose={e => setIsSignupForm(false)}
        title="" canOutsideClickClose={false} isOpen={isSignupForm}>
        <SignUp setIsSignupForm={setIsSignupForm} />
      </Dialog>
    </div>
  );
}
export default withLocalize(withRouter(HomePage));
